<footer>
	<div class="footer-item">
		<h2 i18n>Contacto</h2>
		<div>
			<p><b>{{ environment.contact.bogota.city }} - {{ environment.contact.bogota.country }}</b></p>
			<p><b><a [href]="environment.contact.bogota.mapUrl" target="_blank" class="wrapped">{{ environment.contact.bogota.line1 }} {{ environment.contact.bogota.line2 }}</a></b></p>
			<h3 i18n>Horarios</h3>
			<p><b i18n>Lunes a Sábado:</b> {{ environment.contact.bogota.open_hours }}</p>
			<p><b i18n>Domingos:</b> {{ environment.contact.bogota.open_hours_holiday }}</p>
		</div>
		<br>
		<div>
			<p><b>{{ environment.contact.ibague.city }} - {{ environment.contact.ibague.country }}</b></p>
			<p><b><a [href]="environment.contact.ibague.mapUrl" target="_blank" class="wrapped">{{ environment.contact.ibague.line1 }} {{ environment.contact.ibague.line2 }}</a></b></p>
			<h3 i18n>Horarios</h3>
			<p><b i18n>Lunes a Sábado:</b> {{ environment.contact.ibague.open_hours }}</p>
			<p><b i18n>Domingos:</b> {{ environment.contact.ibague.open_hours_holiday }}</p>
		</div>
	</div>
	<div class="footer-item">
		<div>
			<h2 i18n>Agenda tu cita</h2>
			<p><b i18n>Whatsapp Bogotá: </b> <a href="https://wa.me/{{environment.contact.bogota.phone.replace('+','')}}" target="_blank" i18n-aria-label aria-label="Whatsapp Bogotá">{{ environment.contact.bogota.phone | phoneFormat }}</a></p>
			<p><b i18n>Whatsapp Ibagué: </b> <a href="https://wa.me/{{environment.contact.ibague.phone.replace('+','')}}" target="_blank" i18n-aria-label aria-label="Whatsapp Ibagué">{{ environment.contact.ibague.phone | phoneFormat }}</a></p>
		</div>
		<div>
			<a [href]="environment.contact.instagram" target="_blank" i18n-aria-label aria-label="Instagram">
				<mat-icon aria-label="instagram" [svgIcon]="'app-instagram'" class="app-48 app-elevation2 border-round" mat-ripple></mat-icon>
			</a>
		</div>
	</div>
	<div class="legal-links">
		<a [routerLink]="['/privacy-policy']" i18n="@@footer-privacy-policy|Footer link to the privacy policy">Política de privacidad</a>
		<a [routerLink]="['/terms-of-use']" i18n="@@footer-terms-of-use|Footer link to the terms of use">Términos de uso</a>
		<button type="button" class="cookie-settings-button" (click)="openCookieSettings()" i18n="@@footer-cookie-settings|Footer button that reopens the cookie consent banner">Configuración de cookies</button>
	</div>
</footer>
